export default {
  init() {


    (function( $ ){
        $.fn.openMap = function(lat, long) {
            if ((navigator.platform.indexOf("iPhone") != -1) || 
            (navigator.platform.indexOf("iPad") != -1) || 
            (navigator.platform.indexOf("iPod") != -1))
            {

                window.open(`maps://maps.google.com/maps?daddr=${lat},${long}&amp;ll=`);
            }
            else 
            {
                window.open(`https://maps.google.com/maps?daddr=${lat},${long}&amp;ll=`);
            }
            return this;
        }; 
    })( jQuery );

    $( ".thedirection" ).click(function() {
        let lat = $(this).data('lat');
        let lng = $(this).data('long');

        if (!lat || !lng)
        {
            return;
        }

        $(this).openMap(lat, lng);
    });

    $("#animalsSingle").click(function(e)
    {
        if (target == 'select' || target == 'span' || target == 'button' || target == 'input')
        {
            return;
        }
        
        if ($('#animalsSingle .inlinesearch .main').is(":hidden"))
        {
            return;
        }   
        $("#animalsSingle .toggle").toggleClass("opened");
        $(".searchblock").slideToggle('slow');

    });

    $("#animalsArchive").click(function(e)
    {
        let target = e.target.localName;

        if (target == 'select' || target == 'span' || target == 'button' || target == 'input')
        {
            return;
        }
        
        if ($('#animalsArchive .inlinesearch .main').is(":hidden"))
        {
            return;
        }    
        $("#animalsArchive .toggle").toggleClass("opened");
        $(".searchblock").slideToggle('slow');

    });

    $(".joboffer .btn").click(function(e)
    {
        var parent = jQuery(this).parent();
        
        jQuery('.jobcontent', parent).toggleClass('active');
    });

    $('a[href^="http:"], a[href^="https:"]')
    .not("a[href*='awlnsw.com.au']")
    .attr('target', '_blank');
    
    jQuery('input[type=file]').change(function(e){
        jQuery(this).after('<p>' + e.target.files[0].name + '</p>');
    });

    jQuery( "#commonBlock .tabblock:not(.haslink)" ).click(function() {
        let id = jQuery(this).data('id');


        jQuery('#commonBlock .tabblock').each(function () { 
            jQuery(this).removeClass("active");
        });
        
        if (id === undefined)
        {
            return;
        }
        
        jQuery(this).addClass("active");

        let content = jQuery(`#contentBlock .tabcontent[data-id='${id}']`);

        if (!content)
        {
            return;
        }

        if (content.hasClass("active"))
        {
            return;
        }


        jQuery('#contentBlock .tabcontent').each(function () { 
            jQuery(this).removeClass("active");
        });

        content.addClass("active");

        setTimeout(() => {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#contentBlock .tabcontent.active").offset().top - 140
            }, 2000, () => {
                $('div.wpcf7 > form').wpcf7ResizeSignatures();
            });  
        }, 100);

        

    });

    $(window).load(function() {

        $('.internal-menu a').each(function(){
            $(this).width($(this).width() + 7);
        });

        $('.internal-menu span').each(function(){
            $(this).width($(this).width() + 4);
        });

        let commonBlock = $('#commonBlock');

        if (!commonBlock)
        {
            return;
        }

        $('#commonBlock').each(function(){  

            var highestBox = 0;

            $('.tabblock:not(.story) .tab', this).each(function(){
                
                if($(this).height() > highestBox) {
                    highestBox = $(this).height(); 
                }

            });  

            $('.tabblock:not(.story) .tab',this).height(highestBox);
                        
        }); 
   
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js